export default "__VITE_ASSET__a96e0617__"